import config from "@/config";
var wabaPaths = [
    "details",
    "templates",
    "profile",
    "usage",
    "activitylogs",
];
var LEGACY_TO_V2_PATH = {
    details: "details",
    templates: "templates",
    profile: "profile",
    usage: "insights/messages",
    activitylogs: "activity",
};
function mapLegacyPathToV2(path) {
    if (!path)
        return "details";
    return LEGACY_TO_V2_PATH[path];
}
export function generateV2WABAAppURL(_a) {
    var partnerId = _a.partnerId, channelId = _a.channelId, clientId = _a.clientId, path = _a.path;
    var v2Path = mapLegacyPathToV2(path);
    return "".concat(config.hubV2AppUrl, "/partner/").concat(partnerId, "/clients/").concat(clientId, "/numbers/").concat(channelId, "/").concat(v2Path);
}
var useRedirectWABAApp = function (_a) {
    var partnerId = _a.partnerId, channelId = _a.channelId, clientId = _a.clientId;
    function handleRedirectToWABA(path, target) {
        if (target === void 0) { target = "_blank"; }
        var url = generateV2WABAAppURL({
            partnerId: partnerId,
            channelId: channelId,
            clientId: clientId,
            path: path,
        });
        var newWindow = window.open(url, target);
        if (!newWindow) {
            console.error("Failed to open the new window.");
        }
    }
    return {
        handleRedirectToWABA: handleRedirectToWABA,
    };
};
export default useRedirectWABAApp;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlUmVkaXJlY3RXQUJBQXBwLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidXNlUmVkaXJlY3RXQUJBQXBwLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLE1BQU0sTUFBTSxVQUFVLENBQUM7QUFROUIsSUFBTSxTQUFTLEdBQUc7SUFDaEIsU0FBUztJQUNULFdBQVc7SUFDWCxTQUFTO0lBQ1QsT0FBTztJQUNQLGNBQWM7Q0FDTixDQUFDO0FBR1gsSUFBTSxpQkFBaUIsR0FBK0I7SUFDcEQsT0FBTyxFQUFFLFNBQVM7SUFDbEIsU0FBUyxFQUFFLFdBQVc7SUFDdEIsT0FBTyxFQUFFLFNBQVM7SUFDbEIsS0FBSyxFQUFFLG1CQUFtQjtJQUMxQixZQUFZLEVBQUUsVUFBVTtDQUN6QixDQUFDO0FBRUYsU0FBUyxpQkFBaUIsQ0FBQyxJQUFpQjtJQUMxQyxJQUFJLENBQUMsSUFBSTtRQUFFLE9BQU8sU0FBUyxDQUFDO0lBQzVCLE9BQU8saUJBQWlCLENBQUMsSUFBSSxDQUFDLENBQUM7QUFDakMsQ0FBQztBQUlELE1BQU0sVUFBVSxvQkFBb0IsQ0FBQyxFQU9wQztRQU5DLFNBQVMsZUFBQSxFQUNULFNBQVMsZUFBQSxFQUNULFFBQVEsY0FBQSxFQUNSLElBQUksVUFBQTtJQUlKLElBQU0sTUFBTSxHQUFHLGlCQUFpQixDQUFDLElBQUksQ0FBQyxDQUFDO0lBQ3ZDLE9BQU8sVUFBRyxNQUFNLENBQUMsV0FBVyxzQkFBWSxTQUFTLHNCQUFZLFFBQVEsc0JBQVksU0FBUyxjQUFJLE1BQU0sQ0FBRSxDQUFDO0FBQ3pHLENBQUM7QUFFRCxJQUFNLGtCQUFrQixHQUFHLFVBQUMsRUFBeUM7UUFBdkMsU0FBUyxlQUFBLEVBQUUsU0FBUyxlQUFBLEVBQUUsUUFBUSxjQUFBO0lBQzFELFNBQVMsb0JBQW9CLENBQzNCLElBQWlCLEVBQ2pCLE1BQWdDO1FBQWhDLHVCQUFBLEVBQUEsaUJBQWdDO1FBRWhDLElBQU0sR0FBRyxHQUFHLG9CQUFvQixDQUFDO1lBQy9CLFNBQVMsV0FBQTtZQUNULFNBQVMsV0FBQTtZQUNULFFBQVEsVUFBQTtZQUNSLElBQUksTUFBQTtTQUNMLENBQUMsQ0FBQztRQUVILElBQU0sU0FBUyxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUMsR0FBRyxFQUFFLE1BQU0sQ0FBQyxDQUFDO1FBQzNDLElBQUksQ0FBQyxTQUFTLEVBQUU7WUFDZCxPQUFPLENBQUMsS0FBSyxDQUFDLGdDQUFnQyxDQUFDLENBQUM7U0FDakQ7SUFDSCxDQUFDO0lBRUQsT0FBTztRQUNMLG9CQUFvQixzQkFBQTtLQUNyQixDQUFDO0FBQ0osQ0FBQyxDQUFDO0FBRUYsZUFBZSxrQkFBa0IsQ0FBQyJ9